<template>
    <div class="sms-broadcast-text-box-footer">
        <div class="button-row">
            <MergeFieldDropdown
                v-click-outside="() => isMergeFieldDropdownOpen = false"
                :is-open="isMergeFieldDropdownOpen"
                position="bottom-start"
                :merge-field-categories="mergeFieldCategories"
                @select="({ value }) => handleMergeFieldInsert(value)"
            >
                <template #action>
                    <DsIconButton
                        name="merge-field"
                        @click="isMergeFieldDropdownOpen = !isMergeFieldDropdownOpen"
                    />
                </template>
            </MergeFieldDropdown>

            <DsGuide
                v-if="showTemplatesGuide"
                position="top-start"
                :show="showTemplatesGuide"
                data-qa="automation-templates-guide"
                title="Access your templates"
                body-text="Get quick access to your Keap Marketing Number starter templates, your own templates, or go straight to the template manager."
                confirm-text="Ok, got it"
                @confirm="handleTemplatesGuideClose"
            >
                <div slot="reference" class="guide-reference">
                    <TemplateButton
                        :template-type="templateType"
                        :source="source"
                        @insert-template="insertTemplate"
                    />
                </div>
            </DsGuide>
        </div>
    </div>
</template>

<script>
import MergeFieldDropdown from '../shared/MergeFieldDropdown';
import TemplateButton from '../shared/TemplateButton';
import { TEMPLATE_KINDS } from '../shared/template.constants';
import { FTU_TYPES } from '@/ftu.constants';
import { loadFtu, updateFtuItem } from '@/ftu.utils';

import axios from 'axios';

export default {

    components: {
        MergeFieldDropdown, TemplateButton,
    },

    inject: ['$richTextBox'],

    props: {

        userId: String,

        appId: String,

        source: {
            type: String,
            default: 'automation',
        },
        hideTemplateGuide: {
            type: Boolean,
            default: false,
        },
        loadFtuInfo: {
            type: Boolean,
            default: true,
        },
    },

    data() {
        return {
            mergeFieldCategories: [],
            templateType: TEMPLATE_KINDS.KMN_AUTOMATION_CUSTOM,
            ftu: null,
            loadingFtu: false,
            isMergeFieldDropdownOpen: false,
        };
    },

    mounted() {
        this.loadMergeFields();

        if (this.loadFtuInfo) {
            this.loadFtu();
        }
    },


    computed: {
        showTemplatesGuide() {
            return !this.loadingFtu && !this.ftu?.[FTU_TYPES.AUTOMATED_SMS.TEMPLATES] && !this.hideTemplateGuide;
        },
    },

    methods: {
        async loadMergeFields() {
            try {
                const params = new URLSearchParams({ usage: 'sms' });

                ['contact', 'contactCustomFields', 'profile', 'today', 'user'].forEach((category) => {
                    params.append('categories', category);
                });

                const { data } = await axios.get(`/app/merge/fields?${params.toString()}`);

                this.mergeFieldCategories = data.categories;
            } catch (e) {
                this.$toast({ message: 'There was an error loading the available merge fields. Please try again.' });
            }
        },

        handleMergeFieldInsert(val) {
            this.isMergeFieldDropdownOpen = false;

            this.$richTextBox.insertMergeField(val);
        },

        handleTemplatesGuideClose() {
            this.ftu = {
                ...this.ftu,
                [FTU_TYPES.AUTOMATED_SMS.TEMPLATES]: true,
            };

            updateFtuItem(this.appId, this.userId, FTU_TYPES.AUTOMATED_SMS.TEMPLATES, true);

            document.removeEventListener('click', this.handleTemplatesGuideClose);
        },

        async loadFtu() {
            this.loadingFtu = true;
            this.ftu = await loadFtu(this.appId, this.userId);

            if (this.ftu?.[FTU_TYPES.AUTOMATED_SMS.TEMPLATES] !== true) {
                document.addEventListener('click', this.handleTemplatesGuideClose);
            }

            this.loadingFtu = false;
        },

        insertTemplate(template) {
            this.$richTextBox.insertTemplate(template);
        },
    },
};
</script>

<style lang="scss" scoped>
    .sms-broadcast-text-box-footer {
        margin-bottom: 0;
        height: 100%;
    }
    .button-row {
        background-color: $color-ink-050;

        > * {
            margin: $spacing-050;
        }

        justify-content: flex-start;

        button:not(:last-child) {
            @include margin-end($spacing-100);
        }
    }

    .text-box-footer {
        display: flex;
        justify-content: space-between;
        font-size: $font-size-xs;
    }

    .error-message {
        color: $color-red;
    }

    .character-count {
        color: $color-text-subtle;

        &.error {
             color: $color-red;
        }
    }

    .merge-field-tooltip {
        margin: $spacing-200;
        font-size: $font-size-md;
        line-height: $line-height-lg;
    }
</style>
